const listeners = new Set();

export const onThemeChange = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

export const applyTheme = (t) => {
  document.documentElement.classList.toggle("light", t === "light");
  localStorage.setItem("lbd-theme", t);
  listeners.forEach((fn) => fn(t));
};

export const initTheme = () => applyTheme(localStorage.getItem("lbd-theme") || "dark");

export const toggleTheme = () => {
  const next = (localStorage.getItem("lbd-theme") || "dark") === "dark" ? "light" : "dark";
  applyTheme(next);
  return next;
};
